export enum ProjectImage {
  PNG = '.png',
  JPG = '.jpg',
  JPEG = '.jpeg',
}
